import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import c from 'classnames';
import Button from '../../../../Button';
import ActionBarItemContentWrapper from '../ActionBarItemContentWrapper';
import s from './ActionBarB18Link.scss';
/**
 * Renders a view 'b18' Button. Also provides some ActionBar item styling.
 *
 * @deprecated We're moving away from the Button component
 */ const ActionBarB18Link = (_param)=>/*#__PURE__*/ {
    var { className, children } = _param, rest = _object_without_properties(_param, [
        "className",
        "children"
    ]);
    return React.createElement(Button, _object_spread({
        view: "b18",
        className: c(s['root'], className)
    }, rest), /*#__PURE__*/ React.createElement(ActionBarItemContentWrapper, null, children));
};
ActionBarB18Link.displayName = 'ActionBarB18Link';
export default ActionBarB18Link;
